/** 
 * @type {TransactionCategoriesFilter} 
 */ 
 const filter = { 
with: null, 
orderBy: null, 
ids: null, 
account_ids: null, 
types: null, 
currency_ids: null, 
} 
 /** 
 * @returns {TransactionCategoriesFilter} 
 */ 
 export default function () { 
 return JSON.parse(JSON.stringify(filter)); 
 } 



// WEBPACK FOOTER //
// ./resources/js/filters/TransactionCategoriesFilter.js